import React from "react";
// import featureA from "../assets/feature-a.png";
import featureB from "../assets/feature-b.png";
// import featureC from "../assets/feature-c.png";
import Heading from "./UI/Heading";

const Features = () => {
  const FeatureItem = (props) => {
    return (
      <div className="z-10 cursor-pointer group">
        <img src={props.src} className="w-44" alt="features"></img>
        <h1 className={`${props.className} mt-12 text-white text-lg group-hover:text-neon`}>{props.text}</h1>
      </div>
    );
  };

  return (
    <section className="w-1/2 mx-auto mt-64 text-center">
      <Heading text="Features" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 place-items-center gap-y-12 md:gap-x-12 xl:gap-x-0 mt-20">
        <FeatureItem src={featureB} text="Monitor" />
        <FeatureItem src={featureB} text="Sniper" />
        <FeatureItem src={featureB} text="Monitor" />
      </div>
    </section>
  );
};

export default Features;
